import { render, staticRenderFns } from "./EmailTextarea.vue?vue&type=template&id=386270b4&"
import script from "./EmailTextarea.vue?vue&type=script&lang=js&"
export * from "./EmailTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EmailTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports